import { captureCampaignLocation } from "./services/marketing/campaign-context";
import { funnelService } from "./services/marketing/funnel-service";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { validateEnv } from "./utils/env";
import { Analytics } from "@vercel/analytics/react";
import { initAnalytics } from "./utils/monitoring/analytics";
import { initMetaPixel } from "./utils/monitoring/meta-pixel";

console.log("Application initialization started");

// Mobile viewport height fix for iOS Safari
const setVh = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

try {
  // Validate environment variables before starting the app
  validateEnv();
  console.log("Environment validation successful");

  // Start analytics before render so the landing pageview + funnel events are
  // captured. Each no-ops unless its id/key is configured: PostHog on
  // VITE_POSTHOG_KEY, the Meta Pixel on VITE_META_PIXEL_ID.
  initAnalytics();
  initMetaPixel();
  captureCampaignLocation(window.location.pathname, window.location.search);
  funnelService.resume();

  const rootElement = document.getElementById("root");
  if (!rootElement) {
    throw new Error("Root element not found");
  }

  console.log("Creating React root");
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
      <Analytics />
    </React.StrictMode>,
  );
  console.log("React root created and rendered");

  window.addEventListener("resize", setVh);
  window.addEventListener("orientationchange", setVh);
  setVh();
} catch (error) {
  console.error("Failed to initialize application:", error);
  // Display a user-friendly error message
  const errorElement = document.createElement("div");
  errorElement.style.padding = "20px";
  errorElement.style.color = "red";
  errorElement.textContent =
    "Failed to load the application. Please try refreshing the page.";
  document.body.appendChild(errorElement);
}
